<template>
  <div>
    <LoadingModal :is-loading="isLoading" custom-text="Идет загрузка"/>

    <v-form ref="form">

      <v-col sm="8" class="pa-0">
        <p class="pa-0 ma-0">Номер нового индекса рода:</p>
        <v-text-field
            autocomplete="off"
            v-model="genusIndexNumber"
            :rules="indexRules"
            required
            name="title"
            clearable
            class="mt-0 pt-0"
        />
      </v-col>

      <v-col sm="8" class="pa-0">
        <p class="pa-0 ma-0">Связанный с индексом список родов:</p>
        <v-combobox
            class="mt-0 pa-0"
            v-model="genusList"
            multiple
            persistent-hint
            chips
            append-icon=""
        >
          <template v-slot:append-outer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-information</v-icon>
              </template>
              <span>
                При вводе каждый род отделяется от предыдущего нажатием Enter
              </span>
            </v-tooltip>
          </template>
        </v-combobox>
      </v-col>

      <v-row class="pt-5">
        <v-col sm="8">
          <v-btn
              class="rounded-0"
              color="grey darken-1"
              outlined
              @click="createNewGenusIndex"
          >
            сохранить
          </v-btn>
        </v-col>

      </v-row>
    </v-form>
  </div>
</template>

<script>
import LoadingModal from "@/components/UI/LoadingModal";
import {createGenusIndex, findGenusIndexByGenus} from "@/services/genusIndexAPI";
import ToastService from '@/services/toastService';

export default {
  name: 'IndexAndGenusCreateComponent',

  components: {LoadingModal},

  data() {
    return {
      isLoading: false,
      genusIndexNumber: "",
      genusList: [],
      indexRules: [
        v => !!v || 'Поле не может быть пустым'
      ],
    }
  },

  methods: {
    async createNewGenusIndex () {
      if (!this.$refs.form.validate()) throw new Error(`can't miss out on any field`)
      this.isLoading = true
      await createGenusIndex(this.genusIndexNumber, this.genusList)
          .then((data) => {
            ToastService.toastSuccess("Индекс рода успешно добавлен")
            this.reset()
          })
          .catch((e) => {
            if (e.response.status === 404) {
              ToastService.toastError("Ошибка сервера")
            }
          })
          .finally(() => {
            this.isLoading = false
          })
    },

    reset () {
      this.$refs.form.reset()
    },
  }
};
</script>

<style scoped>

</style>